export default __webpack_public_path__ + "static/media/006-shovel.31d252f6.svg";